import { render, staticRenderFns } from "./SampleItem.vue?vue&type=template&id=43f0876d&scoped=true&"
import script from "./SampleItem.vue?vue&type=script&lang=js&"
export * from "./SampleItem.vue?vue&type=script&lang=js&"
import style0 from "./SampleItem.vue?vue&type=style&index=0&id=43f0876d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f0876d",
  null
  
)

export default component.exports